import { ApiClient, PublicApiClient } from '../../../setup/axios/SetupAxios';
import { ListQueryParams } from '../ApiClient';

export class HazardTypeQueryParams extends ListQueryParams {
    WithEnabled(value: boolean) {
        this.WithParam('active', value)
        return this
    }
}

export class HazardTypeClient {
    static async List(params: HazardTypeQueryParams) {
        return await ApiClient.Get('/hazard-type' + params.GenerateQueryString());
    }
    static async PublicList(params: HazardTypeQueryParams) {
        return await PublicApiClient.Get('/hazard-type/public-list' + params.GenerateQueryString());
    }

    static async Delete(id: string) {
        return await ApiClient.Delete('/hazard-type/' + id);
    }

    static async Get(id: string) {
        return await ApiClient.Get('/hazard-type/' + id);
    }

    static async Create(name: string, color: string, active: boolean) {
        return await ApiClient.Post('/hazard-type/', {
            name,
            color,
            active,
        });
    }

    static async Update(id: string, name: string, color: string, active: boolean) {
        return await ApiClient.Patch('/hazard-type/' + id, [
            {
                op: 'replace',
                path: 'name',
                value: name,
            },
            {
                op: 'replace',
                path: 'color',
                value: color,
            },
            {
                op: 'replace',
                path: 'active',
                value: active,
            },
        ]);
    }
}
